import React, { createContext, useContext } from "react";
import { useAuthBridge } from "./useAuthBridge";

type AuthBridgeReturn = ReturnType<typeof useAuthBridge>;

const AuthBridgeContext = createContext<AuthBridgeReturn | null>(null);

export function AuthBridgeProvider({ children }: { children: React.ReactNode }) {
  const auth = useAuthBridge();
  return (
    <AuthBridgeContext.Provider value={auth}>
      {children}
    </AuthBridgeContext.Provider>
  );
}

export function useSharedAuthBridge(): AuthBridgeReturn {
  const ctx = useContext(AuthBridgeContext);
  if (!ctx) throw new Error("useSharedAuthBridge must be inside AuthBridgeProvider");
  return ctx;
}
